import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var UserMinus02 = function UserMinus02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 7h6m-6 14v-1.2c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C13.7202 15 12.8802 15 11.2 15H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5c0 1.933-1.567 3.5-3.5 3.5S5.5 9.433 5.5 7.5 7.067 4 9 4s3.5 1.567 3.5 3.5"
    })
  }));
};
export default UserMinus02;